<div class="h-screen w-screen">
	<mg-layout
		[version]="version"
		[listSidebar]="listSidebar"
		[url]="url"
		[loading]="loading"
		[ids]="ids"
	>
		<router-outlet mg-router></router-outlet>
	</mg-layout>
</div>
